(function () {
  const TROPHY_SVG =
    '<svg class="wc-matches__section-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M4 18V16H8V12.9C7.18333 12.7167 6.45417 12.3708 5.8125 11.8625C5.17083 11.3542 4.7 10.7167 4.4 9.95C3.15 9.8 2.10417 9.25417 1.2625 8.3125C0.420833 7.37083 0 6.26667 0 5V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H4V0H14V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V5C18 6.26667 17.5792 7.37083 16.7375 8.3125C15.8958 9.25417 14.85 9.8 13.6 9.95C13.3 10.7167 12.8292 11.3542 12.1875 11.8625C11.5458 12.3708 10.8167 12.7167 10 12.9V16H14V18H4ZM4 7.8V4H2V5C2 5.63333 2.18333 6.20417 2.55 6.7125C2.91667 7.22083 3.4 7.58333 4 7.8ZM9 11C9.83333 11 10.5417 10.7083 11.125 10.125C11.7083 9.54167 12 8.83333 12 8V2H6V8C6 8.83333 6.29167 9.54167 6.875 10.125C7.45833 10.7083 8.16667 11 9 11ZM14 7.8C14.6 7.58333 15.0833 7.22083 15.45 6.7125C15.8167 6.20417 16 5.63333 16 5V4H14V7.8Z" fill="#6edb00"/></svg>';

  const BALL_SVG =
    '<svg class="wc-matches__section-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.5"/><path d="M9 1.5L11.2 6.3L16.5 6.8L12.5 10.2L13.6 15.5L9 13L4.4 15.5L5.5 10.2L1.5 6.8L6.8 6.3L9 1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>';

  const CHEVRON_SVG =
    '<svg class="wc-matches__chevron" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const DEFAULT_ACTIVE_VIEW = 'finals';

  const DEFAULT_STRINGS = {
    standingsGroupPrefix: 'Group',
    standingsTeam: 'Team',
    standingsPlayed: 'P',
    standingsWon: 'W',
    standingsDrawn: 'D',
    standingsLost: 'L',
    standingsPoints: 'Pts',
    tbd: 'TBD',
    loadingMatches: 'Loading matches...',
    noMatches: 'No matches available.',
    noStandings: 'No standings available.',
    showMore: 'Show more',
  };

  const COLLAPSIBLE_SECTION_SLUGS = new Set([
    'group-matchday-1',
    'group-matchday-2',
    'group-matchday-3',
    'round-of-32',
  ]);

  const DEFAULT_OPEN_SECTIONS = {
    finals: ['third-place', 'final'],
  };

  const initializedRoots = new WeakSet();
  const observedRoots = new WeakSet();

  function getStrings(config) {
    return Object.assign({}, DEFAULT_STRINGS, config?.strings || {});
  }

  function isEnglishLocale(locale) {
    return locale === 'en';
  }

  function translateSlotLabel(label, locale) {
    if (!label || !isEnglishLocale(locale)) return label;

    let text = label.trim();
    if (text === 'Chưa xác định') return 'TBD';

    const groupFirst = text.match(/^Nhất bảng ([A-L])$/);
    if (groupFirst) return '1st Group ' + groupFirst[1];

    const groupSecond = text.match(/^Nhì bảng ([A-L])$/);
    if (groupSecond) return '2nd Group ' + groupSecond[1];

    const bestThird = text.match(/^BXH 3(?: tốt)? \(([^)]+)\)$/);
    if (bestThird) return 'Best 3rd (' + bestThird[1] + ')';

    if (text === 'Đội 3 chưa xác định') return 'TBD 3rd';

    const winner = text.match(/^Thắng (.+)$/);
    if (winner) return 'Winner ' + winner[1];

    const loser = text.match(/^Đội thua (.+)$/);
    if (loser) return 'Loser ' + loser[1];

    return text;
  }

  function translateSectionTitle(label, locale) {
    if (!label || !isEnglishLocale(locale)) return label;

    const matchday = label.match(/^Vòng bảng - Lượt trận (\d+)$/);
    if (matchday) return 'Group Stage - Matchday ' + matchday[1];

    const sectionTitles = {
      'Vòng 1/32': 'Round of 32',
      'Vòng 1/16': 'Round of 16',
      'Tứ kết': 'Quarter-finals',
      'Bán kết': 'Semi-finals',
      'Tranh hạng ba': 'Third Place Play-off',
      'Chung kết': 'Final',
    };

    return sectionTitles[label] || label;
  }

  function formatStandingsGroupTitle(group, strings) {
    const letter = group.groupLetter || '';
    if (!letter) return strings.standingsGroupPrefix;
    return strings.standingsGroupPrefix + ' ' + letter;
  }

  function readConfig(root) {
    const configEl = root.closest('.wc-matches-wrap')?.querySelector('[data-wc-config]');
    if (!configEl) return null;
    try {
      return JSON.parse(configEl.textContent || '');
    } catch {
      return null;
    }
  }

  function normalizeApiBase(raw) {
    const value = (raw || '').trim().replace(/\/$/, '');
    if (!value) return '';
    if (/^https?:\/\//i.test(value)) return value;
    return 'https://' + value;
  }

  function isDesignMode() {
    return Boolean(window.Shopify && Shopify.designMode);
  }

  function isValidBundle(payload) {
    return Boolean(payload?.competition && payload?.matches);
  }

  function initSection(root) {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);

    try {
      const config = readConfig(root);
      if (!config) {
        showStatus(root, 'Configuration is missing.', true);
        return;
      }

      config.strings = getStrings(config);

      const state = {
        config: config,
        activeView: DEFAULT_ACTIVE_VIEW,
        openSections: new Map(),
        bundle: null,
        renderedViews: new Set(),
      };

      const tabsEl = root.querySelector('[data-wc-tabs]');
      const bodyEl = root.querySelector('[data-wc-body]');
      const panelsWrap = root.querySelector('[data-wc-panels]');
      const panelEls = new Map();

      if (!tabsEl || !bodyEl || !panelsWrap) {
        showStatus(root, 'Section markup is incomplete.', true);
        return;
      }

      root.querySelectorAll('[data-wc-panel]').forEach(function (panel) {
        panelEls.set(panel.dataset.view, panel);
      });

      bindTabs(tabsEl, state, function (view) {
        activateTab(tabsEl, panelEls, state, view);
      });
      activateTab(tabsEl, panelEls, state, state.activeView);

      showStatus(root, config.strings.loadingMatches, false);

      loadBundle(config)
        .then(function (bundle) {
          state.bundle = bundle;
          applySectionTitleOverrides(bundle, getSectionTitleMap(config));
          ensurePanelRendered(state, panelEls, state.activeView);
          hideStatusShowPanels(root, panelsWrap);
        })
        .catch(function (error) {
          showStatus(root, error.message || 'Unable to load match data.', true);
        });
    } catch (error) {
      showStatus(root, error.message || 'Unable to initialize matches.', true);
    }
  }

  function bindTabs(tabsEl, state, onSelect) {
    tabsEl.querySelectorAll('.wc-matches__tab').forEach(function (button) {
      button.addEventListener('click', function () {
        const view = button.dataset.view;
        if (!view || view === state.activeView) return;
        onSelect(view);
      });
    });
  }

  function activateTab(tabsEl, panelEls, state, view) {
    state.activeView = view;

    tabsEl.querySelectorAll('.wc-matches__tab').forEach(function (button) {
      const isActive = button.dataset.view === view;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panelEls.forEach(function (panel, panelView) {
      const isActive = panelView === view;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    ensurePanelRendered(state, panelEls, view);
  }

  function loadBundle(config) {
    if (config.dataSource === 'editor-preview') {
      if (!config.editorPreviewUrl) {
        return Promise.reject(new Error('Theme editor preview URL is not configured.'));
      }
      return fetchJson(config.editorPreviewUrl, 'Failed to load theme editor preview').then(function (payload) {
        if (!isValidBundle(payload)) {
          throw new Error('Theme editor preview data is incomplete.');
        }
        if (!payload.matches.standings) {
          payload.matches.standings =
            payload.standings || buildEmptyStandingsFromMatches(payload.matches, config.strings);
        }
        return payload;
      });
    }

    const apiBase = normalizeApiBase(config.apiBase);
    if (!apiBase) {
      return Promise.reject(new Error('API base URL is not configured.'));
    }

    return fetchJson(apiBase + '/api/bundle', 'Failed to load match data').then(function (payload) {
      if (!isValidBundle(payload)) {
        throw new Error('Match bundle data is incomplete.');
      }
      return payload;
    });
  }

  function buildEmptyStandingsFromMatches(matches, strings) {
    const resolvedStrings = strings || DEFAULT_STRINGS;
    const groups = new Map();
    const sections = matches?.matches?.sections || [];

    sections.forEach(function (section) {
      section.matches.forEach(function (match) {
        if (!match.groupLetter) return;

        const groupKey = match.groupLetter;
        const group = groups.get(groupKey) || {
          groupId: groupKey,
          groupLetter: groupKey,
          title: formatStandingsGroupTitle({ groupLetter: groupKey }, resolvedStrings),
          teams: new Map(),
        };

        addTeamToStandingGroup(group, match.homeTeam);
        addTeamToStandingGroup(group, match.awayTeam);
        groups.set(groupKey, group);
      });
    });

    return {
      groups: Array.from(groups.values())
        .sort(function (a, b) {
          return a.groupLetter.localeCompare(b.groupLetter);
        })
        .map(function (group) {
          const teams = Array.from(group.teams.values())
            .sort(function (a, b) {
              return a.team.name.localeCompare(b.team.name);
            })
            .map(function (team, index) {
              return Object.assign({}, team, { position: index + 1 });
            });

          return {
            groupId: group.groupId,
            groupLetter: group.groupLetter,
            title: group.title,
            teams: teams,
          };
        }),
    };
  }

  function addTeamToStandingGroup(group, team) {
    if (!team?.id) return;
    if (group.teams.has(team.id)) return;

    group.teams.set(team.id, {
      position: 0,
      team: team,
      played: 0,
      won: 0,
      drawn: 0,
      lost: 0,
      points: 0,
    });
  }

  function getSectionTitleMap(config) {
    return Object.assign({}, config.sectionTitles || {}, config.sectionBlockOverrides || {});
  }

  function applySectionTitleOverrides(bundle, overrides) {
    if (!overrides || !bundle.matches) return;
    Object.keys(bundle.matches).forEach(function (view) {
      const viewData = bundle.matches[view];
      if (!viewData?.sections) return;
      viewData.sections.forEach(function (section) {
        if (overrides[section.slug]) {
          section.headerLabel = overrides[section.slug];
        }
      });
    });
  }

  function getSectionHeaderLabel(section, config) {
    const label = section.headerLabel || section.title;
    return translateSectionTitle(label, config?.locale);
  }

  function ensurePanelRendered(state, panelEls, view) {
    if (!state.bundle || state.renderedViews.has(view)) return;

    const panelEl = panelEls.get(view);
    if (!panelEl) return;

    renderPanel(panelEl, view, state.bundle, state.config.openFirst, state.openSections, state.config);
    state.renderedViews.add(view);
  }

  function renderPanel(panelEl, view, bundle, openFirst, openSections, config) {
    const viewData = bundle.matches[view];

    if (view === 'standings') {
      panelEl.innerHTML = '';
      panelEl.appendChild(buildStandingsRoot(viewData?.groups || [], config));
      return;
    }

    const sections = viewData?.sections || [];
    if (!openSections.has(view)) {
      const defaultOpen = DEFAULT_OPEN_SECTIONS[view];
      if (defaultOpen) {
        openSections.set(view, new Set(defaultOpen));
      } else if (openFirst && sections[0]) {
        openSections.set(view, new Set([sections[0].slug]));
      }
    }
    const openSlugs = openSections.get(view) || new Set();
    panelEl.innerHTML = '';
    panelEl.appendChild(buildSectionsRoot(sections, openSlugs, view, openSections, config, config.strings));
  }

  function buildSectionsRoot(sections, openSlugs, view, openSections, config, strings) {
    if (!sections.length) {
      const empty = document.createElement('div');
      empty.className = 'wc-matches__empty';
      empty.textContent = strings.noMatches;
      return empty;
    }

    const wrap = document.createElement('div');
    wrap.className = 'wc-matches__sections';

    sections.forEach(function (section) {
      const isOpen = openSlugs.has(section.slug);
      wrap.appendChild(buildSection(section, isOpen, view, openSections, config));
    });

    return wrap;
  }

  function buildStandingsRoot(groups, config) {
    const resolvedStrings = config?.strings || DEFAULT_STRINGS;
    if (!groups.length) {
      const empty = document.createElement('div');
      empty.className = 'wc-matches__empty';
      empty.textContent = resolvedStrings.noStandings;
      return empty;
    }

    const wrap = document.createElement('div');
    wrap.className = 'wc-standings';

    groups.forEach(function (group) {
      wrap.appendChild(buildStandingsGroup(group, config));
    });

    return wrap;
  }

  function buildStandingsGroup(group, config) {
    const resolvedStrings = config?.strings || DEFAULT_STRINGS;
    const card = document.createElement('article');
    card.className = 'wc-standings__group';

    const title = document.createElement('h3');
    title.className = 'wc-standings__title';
    title.textContent = formatStandingsGroupTitle(group, resolvedStrings);

    const table = document.createElement('table');
    table.className = 'wc-standings__table';

    const thead = document.createElement('thead');
    thead.innerHTML =
      '<tr>' +
      '<th scope="col" class="wc-standings__rank">#</th>' +
      '<th scope="col" class="wc-standings__team-heading">' +
      escapeHtml(resolvedStrings.standingsTeam) +
      '</th>' +
      '<th scope="col">' +
      escapeHtml(resolvedStrings.standingsPlayed) +
      '</th>' +
      '<th scope="col">' +
      escapeHtml(resolvedStrings.standingsWon) +
      '</th>' +
      '<th scope="col">' +
      escapeHtml(resolvedStrings.standingsDrawn) +
      '</th>' +
      '<th scope="col">' +
      escapeHtml(resolvedStrings.standingsLost) +
      '</th>' +
      '<th scope="col">' +
      escapeHtml(resolvedStrings.standingsPoints) +
      '</th>' +
      '</tr>';

    const tbody = document.createElement('tbody');
    const teams = group.teams || [];

    teams.forEach(function (standing, index) {
      tbody.appendChild(buildStandingRow(standing, index, config));
    });

    table.appendChild(thead);
    table.appendChild(tbody);
    card.appendChild(title);
    card.appendChild(table);
    return card;
  }

  function buildStandingRow(standing, index, config) {
    const resolvedStrings = config?.strings || DEFAULT_STRINGS;
    const row = document.createElement('tr');
    const position = standing.position || index + 1;
    const team = standing.team || {};

    row.appendChild(buildStandingCell(position, 'wc-standings__rank'));

    const teamCell = document.createElement('td');
    teamCell.className = 'wc-standings__team-cell';

    const teamWrap = document.createElement('span');
    teamWrap.className = 'wc-standings__team';

    const logo = team.logoUrl
      ? Object.assign(document.createElement('img'), {
          className: 'wc-standings__logo',
          src: team.logoUrl,
          alt: '',
          loading: 'lazy',
          width: 24,
          height: 18,
        })
      : Object.assign(document.createElement('span'), { className: 'wc-standings__logo-placeholder' });

    const name = document.createElement('span');
    name.className = 'wc-standings__team-name';
    name.textContent = team.name
      ? translateSlotLabel(team.name, config?.locale)
      : resolvedStrings.tbd;

    teamWrap.appendChild(logo);
    teamWrap.appendChild(name);
    teamCell.appendChild(teamWrap);
    row.appendChild(teamCell);

    row.appendChild(buildStandingCell(numberOrZero(standing.played)));
    row.appendChild(buildStandingCell(numberOrZero(standing.won)));
    row.appendChild(buildStandingCell(numberOrZero(standing.drawn)));
    row.appendChild(buildStandingCell(numberOrZero(standing.lost)));
    row.appendChild(buildStandingCell(numberOrZero(standing.points), 'wc-standings__points'));

    return row;
  }

  function buildStandingCell(value, className) {
    const cell = document.createElement('td');
    if (className) cell.className = className;
    cell.textContent = String(value);
    return cell;
  }

  function numberOrZero(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function buildAccordionIconHtml(config) {
    const iconType = config?.accordionIcon || 'trophy';
    if (iconType === 'none') return '';
    if (iconType === 'custom' && config.accordionIconUrl) {
      return (
        '<img class="wc-matches__section-icon wc-matches__section-icon--image" src="' +
        escapeHtml(config.accordionIconUrl) +
        '" alt="" width="18" height="18" loading="lazy">'
      );
    }
    if (iconType === 'ball') return BALL_SVG;
    return TROPHY_SVG;
  }

  function buildSection(section, isOpen, view, openSections, config) {
    const sectionEl = document.createElement('article');
    sectionEl.className = 'wc-matches__section' + (isOpen ? ' is-open' : '');
    sectionEl.dataset.sectionSlug = section.slug;

    const header = document.createElement('button');
    header.type = 'button';
    header.className = 'wc-matches__section-header';
    header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    header.innerHTML =
      '<span class="wc-matches__section-title-wrap">' +
      buildAccordionIconHtml(config) +
      '<span class="wc-matches__section-title">' +
      escapeHtml(getSectionHeaderLabel(section, config)) +
      '</span></span>' +
      CHEVRON_SVG;

    header.addEventListener('click', function () {
      const nextOpen = !sectionEl.classList.contains('is-open');
      sectionEl.classList.toggle('is-open', nextOpen);
      header.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');

      let slugs = openSections.get(view);
      if (!slugs) {
        slugs = new Set();
        openSections.set(view, slugs);
      }
      if (nextOpen) slugs.add(section.slug);
      else {
        slugs.delete(section.slug);
        resetShowMore(sectionEl);
      }
    });

    const body = document.createElement('div');
    body.className = 'wc-matches__section-body';
    const list = document.createElement('div');
    list.className = 'wc-matches__match-list';
    section.matches.forEach(function (match) {
      list.appendChild(buildRow(match, config));
    });
    body.appendChild(list);

    sectionEl.appendChild(header);
    sectionEl.appendChild(body);
    maybeAddShowMore(sectionEl, body, list, section, config);
    return sectionEl;
  }

  function maybeAddShowMore(sectionEl, body, list, section, config) {
    if (!COLLAPSIBLE_SECTION_SLUGS.has(section.slug)) return;

    sectionEl.classList.add('is-collapsible');
    sectionEl.classList.add('is-content-collapsed');
    body.classList.add('wc-matches__section-body--limited');

    requestAnimationFrame(function () {
      if (list.scrollHeight <= 265) {
        sectionEl.classList.remove('is-collapsible', 'is-content-collapsed');
        body.classList.remove('wc-matches__section-body--limited');
        return;
      }

      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'wc-matches__show-more';
      toggle.textContent = config?.strings?.showMore || DEFAULT_STRINGS.showMore;

      toggle.addEventListener('click', function () {
        sectionEl.classList.remove('is-content-collapsed');
        sectionEl.classList.add('is-content-expanded');
        toggle.hidden = true;
      });

      sectionEl.appendChild(toggle);
    });
  }

  function resetShowMore(sectionEl) {
    if (!sectionEl.classList.contains('is-collapsible')) return;

    const toggle = sectionEl.querySelector('.wc-matches__show-more');
    sectionEl.classList.add('is-content-collapsed');
    sectionEl.classList.remove('is-content-expanded');
    if (toggle) toggle.hidden = false;
  }

  function buildRow(match, config) {
    const row = document.createElement('div');
    row.className = 'wc-matches__row';

    const group = document.createElement('div');
    group.className = 'wc-matches__group';
    group.textContent = match.groupLetter || '-';

    row.appendChild(group);
    row.appendChild(buildTeam(match.homeTeam, 'home', config));
    row.appendChild(buildCenterCell(match));
    row.appendChild(buildTeam(match.awayTeam, 'away', config));
    return row;
  }

  function buildTeam(team, side, config) {
    const el = document.createElement('div');
    el.className = 'wc-matches__team wc-matches__team--' + side;

    const name = document.createElement('span');
    name.className = 'wc-matches__team-name';
    name.textContent = team.name
      ? translateSlotLabel(team.name, config?.locale)
      : config?.strings?.tbd || DEFAULT_STRINGS.tbd;

    const logo = team.logoUrl
      ? Object.assign(document.createElement('img'), {
          className: 'wc-matches__logo',
          src: team.logoUrl,
          alt: '',
          loading: 'lazy',
          width: 32,
          height: 22,
        })
      : Object.assign(document.createElement('span'), { className: 'wc-matches__logo-placeholder' });

    if (side === 'home') {
      el.appendChild(name);
      el.appendChild(logo);
    } else {
      el.appendChild(logo);
      el.appendChild(name);
    }
    return el;
  }

  function buildCenterCell(match) {
    const cell = document.createElement('div');
    if (match.hasScore) {
      cell.className = 'wc-matches__center wc-matches__score has-result';
      if (match.hasPenalty) {
        appendScorePart(cell, match.homeScore);
        appendPenaltyPart(cell, match.homePenaltyScore);
        appendScoreSeparator(cell);
        appendScorePart(cell, match.awayScore);
        appendPenaltyPart(cell, match.awayPenaltyScore);
      } else {
        cell.textContent = match.homeScore + ' - ' + match.awayScore;
      }
      return cell;
    }

    cell.className = 'wc-matches__center wc-matches__kickoff';
    cell.innerHTML =
      '<span class="wc-matches__time">' +
      escapeHtml(match.time) +
      '</span><span class="wc-matches__date">' +
      escapeHtml(match.date) +
      '</span>';
    return cell;
  }

  function appendScorePart(root, value) {
    const span = document.createElement('span');
    span.className = 'wc-matches__score-main';
    span.textContent = String(value);
    root.appendChild(span);
  }

  function appendPenaltyPart(root, value) {
    const span = document.createElement('span');
    span.className = 'wc-matches__score-penalty';
    span.textContent = '(' + String(value) + ')';
    root.appendChild(span);
  }

  function appendScoreSeparator(root) {
    const span = document.createElement('span');
    span.className = 'wc-matches__score-separator';
    span.textContent = '-';
    root.appendChild(span);
  }

  function showStatus(root, message, isError) {
    const statusEl = root.querySelector('[data-wc-status]');
    const panelsWrap = root.querySelector('[data-wc-panels]');
    if (!statusEl) return;
    statusEl.hidden = false;
    statusEl.setAttribute('aria-busy', 'true');
    statusEl.innerHTML =
      '<span class="' +
      (isError ? 'wc-matches__error' : 'wc-matches__loading') +
      '">' +
      escapeHtml(message) +
      '</span>';
    if (panelsWrap) panelsWrap.hidden = true;
  }

  function hideStatusShowPanels(root, panelsWrap) {
    const statusEl = root.querySelector('[data-wc-status]');
    if (statusEl) statusEl.remove();
    root.classList.add('is-ready');
    root.setAttribute('aria-busy', 'false');
    if (panelsWrap) panelsWrap.hidden = false;
  }

  async function fetchJson(url, errorPrefix) {
    const response = await fetch(url, {
      mode: 'cors',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) {
      throw new Error(errorPrefix + ' (' + response.status + ').');
    }
    return response.json();
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  const countdownTimers = new WeakMap();

  function pad2(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdown(root) {
    const existingTimer = countdownTimers.get(root);
    if (existingTimer) clearInterval(existingTimer);

    const targetMs = Date.parse(root.dataset.target || '');
    if (Number.isNaN(targetMs)) return;

    const timerEl = root.querySelector('.wc-countdown__timer');
    const daysEl = root.querySelector('[data-wc-countdown-days]');
    const hoursEl = root.querySelector('[data-wc-countdown-hours]');
    const minsEl = root.querySelector('[data-wc-countdown-mins]');
    const secsEl = root.querySelector('[data-wc-countdown-secs]');
    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    function endCountdown() {
      root.classList.add('is-ended');
      if (timerEl) timerEl.hidden = true;
      const timerId = countdownTimers.get(root);
      if (timerId) {
        clearInterval(timerId);
        countdownTimers.delete(root);
      }
    }

    function tick() {
      const diffMs = targetMs - Date.now();
      if (diffMs <= 0) {
        endCountdown();
        return;
      }

      const totalSeconds = Math.floor(diffMs / 1000);
      daysEl.textContent = pad2(Math.floor(totalSeconds / 86400));
      hoursEl.textContent = pad2(Math.floor((totalSeconds % 86400) / 3600));
      minsEl.textContent = pad2(Math.floor((totalSeconds % 3600) / 60));
      secsEl.textContent = pad2(totalSeconds % 60);
    }

    tick();
    countdownTimers.set(root, setInterval(tick, 1000));
  }

  function bootMatches(root) {
    if (!root) return;
    root.classList.remove('is-ready');
    initializedRoots.delete(root);
    initSection(root);
  }

  function observeMatchesSection(root) {
    if (!root || observedRoots.has(root) || initializedRoots.has(root)) return;
    observedRoots.add(root);

    if (isDesignMode() || typeof IntersectionObserver !== 'function') {
      bootMatches(root);
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          bootMatches(root);
        });
      },
      { rootMargin: '200px 0px', threshold: 0 },
    );

    observer.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-wc-countdown]').forEach(initCountdown);
    document.querySelectorAll('[data-wc-matches]').forEach(observeMatchesSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (isDesignMode()) {
    setTimeout(boot, 300);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const scope = event.target;
    const countdown = scope.querySelector('[data-wc-countdown]');
    if (countdown) initCountdown(countdown);

    scope.querySelectorAll('[data-wc-matches]').forEach(function (root) {
      observedRoots.delete(root);
      bootMatches(root);
    });
  });
})();
